/// <reference types="@types/googlemaps" />

import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MapsAPILoader } from '@agm/core';
import { LocationService } from '../../services/location.service';
import { LocationType, ProductName } from '../../graphql-client/graphql';
import { Environment } from '../../environment';

@Component({
  selector: 'finders-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss']
})
export class SearchbarComponent implements OnInit {
  public isProlia = true;

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private locationService: LocationService,
    private env: Environment
  ) {
    this.matIconRegistry.addSvgIcon(
      'search',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        './assets/images/svgs/search-icon.svg'
      )
    );

    // Only show dropdown for prolia.
    this.isProlia = this.env.product === ProductName.Prolia;
  }

  public searchControl: FormControl;
  public showIcon = true;
  public locationAddress: string;
  public locationType: LocationType = LocationType.Treatment;

  @Output() recenterMap = new EventEmitter();

  @Input() routerTarget = 'results';
  @Input() locationTypeInput: LocationType;
  @Input() locationAddressInput = '';
  @Input() searchButtonText = 'Find Locations';

  @ViewChild('locationAddress', { static: false })
  public searchInputRef: ElementRef;

  emitRecenterMap() {
    this.recenterMap.emit(true);
  }

  onLocationTypeChange($event) {
    this.locationService.updateLocationType($event);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.locationAddressInput = params.input || params.address || '';
      this.locationType = <LocationType>params.type || LocationType.Treatment;
    });

    if (this.searchButtonText === 'Update Search') {
      this.showIcon = false;
    } else {
      this.showIcon = true;
    }

    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchInputRef.nativeElement
      );

      autocomplete.setComponentRestrictions({ country: ['us'] });

      google.maps.event.addDomListener(
        this.searchInputRef.nativeElement,
        'keydown',
        e => {
          // If keycode is enter
          if (e.keyCode === 13) {
            this.search();
          }
        }
      );

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();

          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          // set latitude, longitude and location address
          this.locationAddressInput = place.formatted_address;

          this.locationService.updateLocation({
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            address: place.formatted_address
          });
        });
      });
    });
  }

  public search() {
    this.locationService.geocode(this.locationAddressInput).then(location => {
      this.ngZone.run(() => {
        this.router.navigate([
          this.routerTarget,
          {
            ...location,
            type: this.locationType,
            input: this.locationAddressInput
          }
        ]);
      });
    });
  }
}
